import React, { useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import Modal, { ModalProvider, BaseModalBackground } from "styled-react-modal";
import { Theme } from "../styles/Theme";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import LabelText from "./LabelText";

const StyledModal = Modal.styled(({ theme }: { theme: Theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    border: ${theme.borderColor};
    background: ${theme.dropdownBorderColor};
    max-width: 508px;
    max-height: 316px;
    padding: 48px;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
    flex-shrink: 0;
    transition : all 0.3s ease-in-out;
`);

const ContentFrame = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  padding-bottom:32px;
  border-bottom:1px solid  ${({ theme }) => theme.playerDataBorder}; 
`;

const ActionContent = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 32px;
    align-self: stretch;
    // margin-top:32px;

    .action-child-content {
      display:flex;
      gap:16px;
      flex: 1;
      align-items: center;

    }
`;

interface SmallModalProps {
  //toggleSmallModal: () => void;
  isOpen: boolean;
  onAcceptClick: () => void;
  onCancelClick: () => void;
  headerMessage: string;
  bodyMessage: string;
  footerMessage: string;
  acceptLabel: string;
  cancelLabel: string;
}
const SmallModal: React.FC<SmallModalProps> = ({ isOpen, onAcceptClick, onCancelClick,
  headerMessage, bodyMessage, footerMessage, acceptLabel, cancelLabel
}) => {

  return (
    <div> 
      
      <StyledModal isOpen={isOpen}>
        <ContentFrame>
          <Content>
            {/* <LabelText className="player-family-name">Clear similar players?</LabelText>
            <LabelText>
              Selecting new areas of operation will clear the selected players from the search criteria as they do not play in that area.
            </LabelText> */}
            <LabelText className="player-family-name">{headerMessage}</LabelText>
            <LabelText>{bodyMessage}</LabelText>
  
          </Content>
          <ActionContent>
            <div className="action-child-content">
              {/* <LabelText className="modal-text">Clear players and perform a new search?</LabelText> */}
              <LabelText className="modal-text">{footerMessage}</LabelText>
            </div>
            <div className="action-child-content">
              {/* <SecondaryButton label="cancel" onClick={onCancelClick} />
              <PrimaryButton label="Yes, do it" onClick={onAcceptClick} /> */}
              <SecondaryButton label={cancelLabel} onClick={onCancelClick} />
              <PrimaryButton label={acceptLabel} onClick={onAcceptClick} />
            </div>
          </ActionContent>
        </ContentFrame>
      </StyledModal>

    </div>
  );
}
export default SmallModal;

